import { NUMBER_OF_VISIBLE_PROMOTIONS } from '../constants';

import { ICountrysidePromoItem } from '@cian/api-models/offer-card/v1/get-offer-data';

export const slicePromotions = (promotions: ICountrysidePromoItem[]) =>
  promotions.length > NUMBER_OF_VISIBLE_PROMOTIONS
  ? promotions.slice(0, NUMBER_OF_VISIBLE_PROMOTIONS)
  : promotions;
